"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableToolbar = exports.ExpandableToolbarState = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const sync = tslib_1.__importStar(require("thingies/lib/sync"));
const _1 = require(".");
const ContextMenu_1 = require("../../ContextMenu");
const PositionAtPoint_1 = require("../../../utils/popup/PositionAtPoint");
const context_1 = require("../../Popup/context");
const ClickAway_1 = require("../../../utils/ClickAway");
const ToolbarMenuProvider_1 = require("./ToolbarMenuProvider");
const MoveToViewport_1 = require("../../../utils/popup/MoveToViewport");
const useSyncStore_1 = require("../../../hooks/useSyncStore");
class ExpandableToolbarState {
    constructor() {
        this.view = sync.val('toolbar');
    }
}
exports.ExpandableToolbarState = ExpandableToolbarState;
const ExpandableToolbar = (props) => {
    const { state: _state, expandPoint, more, context, contextMenu = props.menu, ...rest } = props;
    const state = React.useMemo(() => _state || new ExpandableToolbarState(), [_state]);
    const view = (0, useSyncStore_1.useSyncStore)(state.view);
    const popupContextValue = React.useMemo(() => ({
        close: () => {
            state.view.next('toolbar');
        },
    }), [state]);
    const handleContextMenuClickAway = React.useCallback(() => {
        state.view.next('toolbar');
    }, [state]);
    if (view === 'context') {
        if (!expandPoint)
            return null;
        return (React.createElement(PositionAtPoint_1.PositionAtPoint, { point: typeof expandPoint === 'function' ? expandPoint() : expandPoint },
            React.createElement(ClickAway_1.ClickAway, { onClickAway: handleContextMenuClickAway },
                React.createElement(context_1.context.Provider, { value: popupContextValue },
                    React.createElement(ToolbarMenuProvider_1.ToolbarMenuProvider, { ...rest },
                        React.createElement(MoveToViewport_1.MoveToViewport, null,
                            React.createElement(ContextMenu_1.ContextMenu, { inset: true, showSearch: true, ...context, menu: contextMenu, onEsc: () => state.view.next('toolbar') })))))));
    }
    return (React.createElement(_1.ToolbarMenu, { ...rest, more: {
            ...more,
            onClick: expandPoint
                ? () => {
                    state.view.next('context');
                }
                : undefined,
        } }));
};
exports.ExpandableToolbar = ExpandableToolbar;
